import { render, staticRenderFns } from "./canyinManagement.vue?vue&type=template&id=186e2d68&scoped=true"
import script from "./canyinManagement.vue?vue&type=script&lang=js"
export * from "./canyinManagement.vue?vue&type=script&lang=js"
import style0 from "./canyinManagement.vue?vue&type=style&index=0&id=186e2d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186e2d68",
  null
  
)

export default component.exports